/**
 * Main store — scroll reveals & section animations
 * Loaded only when body.theme-modern (NOT theme-professional)
 */
(function () {
  'use strict';

  var root = document.body;
  if (!root || !root.classList.contains('theme-modern')) return;
  if (root.classList.contains('theme-professional')) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    var targets = document.querySelectorAll('[data-animate]');
    if (!targets.length) return;

    if (prefersReducedMotion) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute('data-animate-delay');
          if (delay) {
            el.style.transitionDelay = delay + 'ms';
          }
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el, index) {
      if (!el.hasAttribute('data-animate-delay') && el.closest('[data-animate-stagger]')) {
        var stagger = el.closest('[data-animate-stagger]');
        var step = parseInt(stagger.getAttribute('data-animate-stagger'), 10) || 80;
        el.style.transitionDelay = index * step + 'ms';
      }
      observer.observe(el);
    });
  }

  function initSmoothScroll() {
    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;

      var target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: top,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });

      if (history.pushState) {
        history.pushState(null, '', hash);
      }
    });
  }

  function initAutoAnimate() {
    var sectionSelectors = [
      '.ishislider',
      '.ishiservices',
      '.ishi-featured-product-tab',
      '.manufacture-block',
      '.ishi-deal-block',
      '.shopify-section[class*="apps"]',
      '.featured-blog'
    ].join(',');

    document.querySelectorAll(sectionSelectors).forEach(function (el, index) {
      if (!el.hasAttribute('data-animate')) {
        el.setAttribute('data-animate', 'fade-up');
        el.setAttribute('data-animate-delay', String(Math.min(index * 70, 420)));
      }
    });

    document.querySelectorAll('.ishiservices .services').forEach(function (el, index) {
      if (!el.hasAttribute('data-animate')) {
        el.setAttribute('data-animate', 'scale-in');
        el.style.transitionDelay = index * 90 + 'ms';
      }
    });

    document.querySelectorAll('.featured-product-section .grid__item, .ishi-featured-product-tab .grid__item').forEach(function (el, index) {
      if (!el.hasAttribute('data-animate')) {
        el.setAttribute('data-animate', 'fade-up');
        el.style.transitionDelay = Math.min(index * 60, 360) + 'ms';
      }
    });
  }

  function initProNav() {
    var nav = document.querySelector('.pro-nav');
    if (!nav) return;

    nav.querySelectorAll('.pro-nav__item--dropdown').forEach(function (item) {
      var trigger = item.querySelector('.pro-nav__link');
      var toggle = item.querySelector('.pro-nav__toggle');

      function setOpen(open) {
        item.classList.toggle('is-open', open);
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !item.classList.contains('is-open');
          nav.querySelectorAll('.pro-nav__item--dropdown.is-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var otherTrigger = other.querySelector('.pro-nav__link');
              var otherToggle = other.querySelector('.pro-nav__toggle');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
            }
          });
          setOpen(willOpen);
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pro-nav__item--dropdown')) {
        nav.querySelectorAll('.pro-nav__item--dropdown.is-open').forEach(function (item) {
          item.classList.remove('is-open');
          var trigger = item.querySelector('.pro-nav__link');
          var toggle = item.querySelector('.pro-nav__toggle');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function init() {
    initAutoAnimate();
    initScrollReveal();
    initSmoothScroll();
    initProNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
